function parseDate(value) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d;
}

function round2(value) {
  return Math.round(value * 100) / 100;
}

export function calculateEndOfService(input) {
  const {
    monthlySalary,
    startDate,
    endDate,
    terminationType,
    contractType,
  } = input;

  const salary = Number(monthlySalary);
  const start = parseDate(startDate);
  const end = parseDate(endDate);

  if (!salary || salary <= 0 || !start || !end || end <= start) {
    return {
      valid: false,
      amount: 0,
      serviceYears: 0,
      salary: 0,
      multiplierRuleKey: "tools.eos.multiplier.employerOrContractEnd",
      assumptionsKeys: [
        "tools.eos.assumption.validSalary",
        "tools.eos.assumption.validDates",
      ],
      notesKeys: [
        "tools.eos.note.preliminary",
      ],
      contractType,
      invalidReason: "invalid-input",
    };
  }

  const diffDays = Math.max(0, (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
  const serviceYears = diffDays / 365;
  const firstFiveYears = Math.min(serviceYears, 5);
  const afterFiveYears = Math.max(0, serviceYears - 5);

  const baseEntitlement =
    (firstFiveYears * 0.5 * salary) +
    (afterFiveYears * 1.0 * salary);

  let multiplier = 1;
  let multiplierRuleKey = "tools.eos.multiplier.employerOrContractEnd";

  if (terminationType === "resignation") {
    if (serviceYears < 2) {
      multiplier = 0;
      multiplierRuleKey = "tools.eos.multiplier.resignation.lt2";
    } else if (serviceYears < 5) {
      multiplier = 1 / 3;
      multiplierRuleKey = "tools.eos.multiplier.resignation.2to5";
    } else if (serviceYears < 10) {
      multiplier = 2 / 3;
      multiplierRuleKey = "tools.eos.multiplier.resignation.5to10";
    } else {
      multiplier = 1;
      multiplierRuleKey = "tools.eos.multiplier.resignation.gte10";
    }
  }

  const estimatedAmount = round2(baseEntitlement * multiplier);

  return {
    valid: true,
    amount: estimatedAmount,
    serviceYears: round2(serviceYears),
    salary: round2(salary),
    multiplierRuleKey,
    assumptionsKeys: [
      "tools.eos.assumption.saudiRule",
      "tools.eos.assumption.exclusions",
      contractType === "fixed"
        ? "tools.eos.assumption.contract.fixed"
        : "tools.eos.assumption.contract.unlimited",
      multiplierRuleKey,
    ],
    notesKeys: [
      "tools.eos.note.preliminary",
      "tools.eos.note.consultLawyer",
    ],
    contractType,
  };
}

